module.exports = __webpack_public_path__ + "static/media/lv_lv.a391bde3.png";